<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            商品ID<template slot="title">商品ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('请输入')+'商品ID'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsName" >
        <span slot="label" >
          <a-tooltip>
            商品名称<template slot="title">商品名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsName" :maxLength="255" :placeholder="$t('请输入')+'商品名称'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsImage" >
        <span slot="label" >
          <a-tooltip>
            商品主图URL<template slot="title">商品主图URL</template>
          </a-tooltip>
        </span>
        <file-upload v-model="form.goodsImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="goodsPrice" >
        <span slot="label" >
          <a-tooltip>
            商品价格<template slot="title">商品价格</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsPrice"  :placeholder="$t('请输入')+'商品价格'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" >
          <a-tooltip>
            用户id<template slot="title">用户id</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+'用户id'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserFootprint, addUserFootprint, updateUserFootprint } from '@/api/user/userFootprint'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        goodsId: null,

        goodsName: null,

        goodsImage: null,

        goodsPrice: null,

        userId: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: '商品ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '商品名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsImage: [
          { required: true, message: '商品主图URL'+this.$t('不能为空'), trigger: 'blur' }
        ],
        goodsPrice: [
          { required: true, message: '商品价格'+this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户id'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodsId: null,
        goodsName: null,
        goodsImage: null,
        goodsPrice: null,
        userId: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserFootprint({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUserFootprint(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUserFootprint(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
